/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-use-before-define */
/* eslint-disable no-nested-ternary */
import React, { useRef, useState, useEffect } from 'react';
import {
  VStack,
  HStack,
  FormControl,
  FormLabel,
  Input,
  Checkbox,
  Button,
  CheckboxGroup,
  Stack,
  Text,
  Box,
  Tooltip,
  Alert,
  AlertIcon,
  AlertTitle,
  AlertDescription,
  Divider,
  Progress,
  useBreakpointValue,
  useColorModeValue,
  Textarea,
} from '@chakra-ui/react';
import SignatureCanvas from 'react-signature-canvas';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

import TermsConditions from './TermsConditions';
import { useAuth } from '../contexts/AuthContext';

const getCompleteAddressSource = (soci = []) =>
  soci.find(
    (socio) =>
      Boolean(socio?.indirizzoVia?.trim()) &&
      Boolean(socio?.indirizzoCitta?.trim()) &&
      Boolean(socio?.indirizzoCap?.trim())
  ) || null;

const getParentSource = (soci = []) =>
  soci.find((socio) => socio?.isMinorenne === false) ||
  soci.find((socio) => Boolean(socio?.nomeGenitore || socio?.nomeSocio)) ||
  soci[0] ||
  null;

const TesseramentoFormMinore = ({ userData, onSubmitSuccess }) => {
  const navigate = useNavigate();
  const { requestUserData } = useAuth();
  const sigCanvas = useRef(null);

  const soci = userData?.tesseramenti || [];
  // users/me ordina i soci dal più recente: non usare [0] come indirizzo di default
  const addressSource = getCompleteAddressSource(soci);
  const hasCompleteAddress = Boolean(addressSource);

  const [formData, setFormData] = useState({
    // Dati del Socio Minore
    nomeSocio: '',
    cognomeSocio: '',
    dataNascitaSocio: '',
    luogoNascitaSocio: '',
    codiceFiscaleSocio: '',
    precauzioniSanitarie: '',
    indirizzoVia: addressSource?.indirizzoVia || '',
    indirizzoCitta: addressSource?.indirizzoCitta || '',
    indirizzoCap: addressSource?.indirizzoCap || '',
    useUserAddress: hasCompleteAddress,
    // Termini e Interessi
    interessi: [],
    autorizzazioneFotografie: true,
    consensoPubblicazione: true,
    terminiCondizioni: false,
    data: new Date().toISOString().split('T')[0],
    luogo: '',
    firma: '',
    // Pagamento
    paymentMethod: '', // 'elettronico' o 'contanti'
    paymentStatus: '', // 'succeeded' o 'pending'
    price: 10,
  });

  const [errors, setErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);
  const [paymentError, setPaymentError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [socioCreated, setSocioCreated] = useState({}); // Stato per il messaggio di successo o errore
  const [submissionStatus, setSubmissionStatus] = useState(null); // Stato per il messaggio di successo o errore
  const [step, setStep] = useState(1); // Stato per il passo corrente

  const createOrder = async ({
    participantId,
    paymentIntentId,
    paymentStatus = 'pending',
    paymentMethod = 'contanti',
  } = {}) => {
    const response = await axios.post('/api/ordini', {
      paymentIntentId,
      paymentStatus,
      paymentMethod,
      amount: 10,
      eventVariants: {
        [participantId]: {
          type: 'tesseramento',
          amount: 10,
          priceOption: 'totale',
          name: `Tesseramento ${formData.nomeSocio}`,
        },
      },
    });

    if (response.status !== 200) {
      setPaymentError(`Errore con la creazione dell'ordine`);
    }
  };

  const options = {
    interessi: [
      'Giochi di carte',
      'Sport',
      'Giochi da tavolo',
      'Pittura & Disegno',
      'Miniature',
      'Videogiochi',
      'Natura & Animali',
      'Avventure Outdoor',
    ],
  };

  const handleChange = (e) => {
    const { id, name, value, type, checked } = e.target;
    const field = id || name;
    if (!field) return;

    setFormData((prevData) => {
      const nextData = {
        ...prevData,
        [field]: type === 'checkbox' ? checked : value,
      };

      // Se si riattiva "usa indirizzo esistente", ripristina subito i campi
      if (field === 'useUserAddress' && checked && addressSource) {
        nextData.indirizzoVia = addressSource.indirizzoVia || '';
        nextData.indirizzoCitta = addressSource.indirizzoCitta || '';
        nextData.indirizzoCap = addressSource.indirizzoCap || '';
      }

      return nextData;
    });
  };

  const handleInteressiChange = (selectedOptions) => {
    setFormData((prevData) => ({
      ...prevData,
      interessi: selectedOptions,
    }));
  };

  const clearSignature = () => {
    if (sigCanvas.current) {
      sigCanvas.current.clear();
    }
    setFormData((prevData) => ({
      ...prevData,
      firma: '',
    }));
  };

  // Effetto per caricare la firma quando si torna allo step successivo
  useEffect(() => {
    if (step === 2) {
      if (formData.firma && sigCanvas.current) {
        sigCanvas.current.fromDataURL(formData.firma);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  // Effetto per validare il form ogni volta che i dati o lo step cambiano
  useEffect(() => {
    validateForm();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData, step]);

  useEffect(() => {
    if (socioCreated?.documentId) {
      setStep(3);
    }
  }, [socioCreated]);

  useEffect(() => {
    if (!formData.useUserAddress || !addressSource) return;

    setFormData((prevData) => {
      if (
        prevData.indirizzoVia === (addressSource.indirizzoVia || '') &&
        prevData.indirizzoCitta === (addressSource.indirizzoCitta || '') &&
        prevData.indirizzoCap === (addressSource.indirizzoCap || '')
      ) {
        return prevData;
      }

      return {
        ...prevData,
        indirizzoVia: addressSource.indirizzoVia || '',
        indirizzoCitta: addressSource.indirizzoCitta || '',
        indirizzoCap: addressSource.indirizzoCap || '',
      };
    });
  }, [
    formData.useUserAddress,
    addressSource?.documentId,
    addressSource?.indirizzoVia,
    addressSource?.indirizzoCitta,
    addressSource?.indirizzoCap,
  ]);

  const validateForm = () => {
    const newErrors = {};

    // Step-based validation
    if (step === 1) {
      if (!formData.nomeSocio) {
        newErrors.nomeSocio = 'Questo campo è obbligatorio';
      }
      if (!formData.cognomeSocio) {
        newErrors.cognomeSocio = 'Questo campo è obbligatorio';
      }
      if (!formData.dataNascitaSocio) {
        newErrors.dataNascitaSocio = 'Questo campo è obbligatorio';
      }
      if (!formData.luogoNascitaSocio) {
        newErrors.luogoNascitaSocio = 'Questo campo è obbligatorio';
      }
      if (!formData.codiceFiscaleSocio) {
        newErrors.codiceFiscaleSocio = 'Questo campo è obbligatorio';
      }
      if (!formData.indirizzoVia) {
        newErrors.indirizzoVia = 'Questo campo è obbligatorio';
      }
      if (!formData.indirizzoCitta) {
        newErrors.indirizzoCitta = 'Questo campo è obbligatorio';
      }
      if (!formData.indirizzoCap) {
        newErrors.indirizzoCap = 'Questo campo è obbligatorio';
      }
      // Evita blocco silenzioso: se l'indirizzo riusato è incompleto, forziamo i campi visibili
      if (
        formData.useUserAddress &&
        (newErrors.indirizzoVia ||
          newErrors.indirizzoCitta ||
          newErrors.indirizzoCap)
      ) {
        newErrors.useUserAddress =
          'Indirizzo incompleto: deseleziona e inseriscilo manualmente';
      }
    }

    if (step === 2) {
      if (!formData.terminiCondizioni) {
        newErrors.terminiCondizioni = 'Devi accettare i termini e condizioni';
      }
      if (!formData.luogo) {
        newErrors.luogo = 'Questo campo è obbligatorio';
      }
      if (!formData.firma && sigCanvas.current && sigCanvas.current.isEmpty()) {
        newErrors.firma = 'La firma è obbligatoria';
      }
    }

    if (step === 3) {
      if (!formData.paymentMethod) {
        newErrors.paymentMethod = 'Seleziona un metodo di pagamento';
      }
      if (formData.paymentMethod === 'elettronico' && paymentError) {
        newErrors.paymentError = paymentError;
      }
    }

    setErrors(newErrors);
    const valid = Object.keys(newErrors).length === 0;
    setIsFormValid(valid);
    return valid;
  };

  const handleNext = () => {
    // Handle saving the signature
    if (step === 2) {
      if (!sigCanvas.current.isEmpty()) {
        const signature = sigCanvas.current
          .getTrimmedCanvas()
          .toDataURL('image/png');

        setFormData((prevData) => ({
          ...prevData,
          firma: signature,
        }));
      } else {
        setFormData((prevData) => ({
          ...prevData,
          firma: '',
        }));
      }
    }

    const valid = validateForm();

    if (valid) {
      if (step === 2) {
        handleSubmit();
      } else {
        setStep((prev) => prev + 1);
      }
    }
  };

  const handleBack = () => {
    setStep((prev) => prev - 1);
  };

  const updateTesseramento = async ({
    status: paymentStatus,
    paymentMethod,
    paymentIntentId,
  } = {}) => {
    try {
      const response = await fetch(
        `/api/tesseramento/${socioCreated.documentId}`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email: socioCreated.email,
            paymentMethod: paymentMethod || 'contanti',
            paymentStatus: paymentStatus || 'pending',
            paymentIntentId: paymentIntentId || '',
          }),
        }
      );

      const jsonResponse = await response.json();

      if (!response.ok) {
        throw new Error(
          `Errore nella sottomissione del form: ${jsonResponse.message}`
        );
      }

      await createOrder({
        participantId: socioCreated.documentId,
        paymentMethod: paymentMethod || 'contanti',
        paymentStatus: paymentStatus || 'pending',
        paymentIntentId: paymentIntentId || '',
      });

      if (onSubmitSuccess) {
        onSubmitSuccess();
      }

      navigate('/account/tesseramenti');
      requestUserData({ withLoading: false });
    } catch (error) {
      console.error('Errore nella sottomissione del form:', error);
      setSubmissionStatus('error');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e = {}) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const valid = validateForm();
    if (!valid) return;

    // La firma è già salvata in formData.firma, non è necessario recuperarla nuovamente dal canvas

    setLoading(true);
    setPaymentError(null);

    if (formData.paymentMethod === 'contanti') {
      updateTesseramento();
      return;
    }

    const tesseramentoGenitore = getParentSource(soci);
    if (!tesseramentoGenitore) {
      setSubmissionStatus('error');
      setLoading(false);
      return;
    }

    // Prepara i dati da inviare, aggiungendo 'username' come 'email'
    const dataToSubmit = {
      ...formData,
      email: tesseramentoGenitore.email,
      nomeGenitore:
        tesseramentoGenitore.nomeGenitore || tesseramentoGenitore.nomeSocio,
      cognomeGenitore:
        tesseramentoGenitore.cognomeGenitore ||
        tesseramentoGenitore.cognomeSocio,
      luogoNascitaGenitore:
        tesseramentoGenitore.luogoNascitaGenitore ||
        tesseramentoGenitore.luogoNascitaSocio,
      codiceFiscaleGenitore:
        tesseramentoGenitore.codiceFiscaleGenitore ||
        tesseramentoGenitore.codiceFiscaleSocio,
      dataNascitaGenitore:
        tesseramentoGenitore.dataNascitaGenitore ||
        tesseramentoGenitore.dataNascitaSocio,
      telefono: tesseramentoGenitore.telefono,
      isMinorenne: true,
    };

    if (!sigCanvas?.current?.isEmpty()) {
      const signature = sigCanvas.current
        .getTrimmedCanvas()
        .toDataURL('image/png');

      dataToSubmit.firma = signature;
    }

    dataToSubmit.paymentStatus = 'pending';
    delete dataToSubmit.useUserAddress;
    try {
      const response = await fetch('/api/tesseramento', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(dataToSubmit),
      });

      const jsonResponse = await response.json();

      if (!response.ok) {
        throw new Error(
          `Errore nella sottomissione del form: ${jsonResponse.message}`
        );
      }

      if (onSubmitSuccess) {
        onSubmitSuccess();
      }

      setSocioCreated(jsonResponse.socio);
      requestUserData({ withLoading: false });
    } catch (error) {
      console.error('Errore nella sottomissione del form:', error);
      setSubmissionStatus('error');
    } finally {
      setLoading(false);
    }
  };

  // Calcola il numero totale di step basato su isMinorenne
  const totalSteps = 3;

  // Responsive layout adjustments
  const formWidth = useBreakpointValue({ base: '100%', md: '600px' });

  // Definizione dei colori in base alla modalità colore
  const formLabelColor = useColorModeValue('black', 'white');
  const formTextColor = useColorModeValue('black', 'white');

  return (
    <Box p={4} maxW={formWidth} mx="auto" width="100%">
      {submissionStatus === 'success' ? (
        <Alert status="success">
          <AlertIcon />
          <AlertTitle>Successo!</AlertTitle>
          <AlertDescription>
            Il tesseramento è avvenuto con successo.
          </AlertDescription>
        </Alert>
      ) : (
        <>
          <Progress
            value={(step / totalSteps) * 100}
            mb="5%"
            colorScheme="teal"
          />
          <form onSubmit={handleSubmit}>
            <VStack spacing={4} align="stretch">
              {step === 1 && (
                <>
                  <FormControl
                    id="nomeSocio"
                    isRequired
                    isInvalid={errors.nomeSocio}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Nome
                    </FormLabel>
                    <Input
                      id="nomeSocio"
                      name="nomeSocio"
                      type="text"
                      value={formData.nomeSocio}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.nomeSocio && (
                      <Text color="red.500" fontSize="sm">
                        {errors.nomeSocio}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="cognomeSocio"
                    isRequired
                    isInvalid={errors.cognomeSocio}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Cognome
                    </FormLabel>
                    <Input
                      id="cognomeSocio"
                      name="cognomeSocio"
                      type="text"
                      value={formData.cognomeSocio}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.cognomeSocio && (
                      <Text color="red.500" fontSize="sm">
                        {errors.cognomeSocio}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="dataNascitaSocio"
                    isRequired
                    isInvalid={errors.dataNascitaSocio}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Data di Nascita
                    </FormLabel>
                    <Input
                      id="dataNascitaSocio"
                      name="dataNascitaSocio"
                      type="date"
                      value={formData.dataNascitaSocio}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.dataNascitaSocio && (
                      <Text color="red.500" fontSize="sm">
                        {errors.dataNascitaSocio}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="luogoNascitaSocio"
                    isRequired
                    isInvalid={errors.luogoNascitaSocio}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Luogo di Nascita
                    </FormLabel>
                    <Input
                      id="luogoNascitaSocio"
                      name="luogoNascitaSocio"
                      type="text"
                      value={formData.luogoNascitaSocio}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.luogoNascitaSocio && (
                      <Text color="red.500" fontSize="sm">
                        {errors.luogoNascitaSocio}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="codiceFiscaleSocio"
                    isRequired
                    isInvalid={errors.codiceFiscaleSocio}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Codice Fiscale
                    </FormLabel>
                    <Input
                      id="codiceFiscaleSocio"
                      name="codiceFiscaleSocio"
                      type="text"
                      value={formData.codiceFiscaleSocio}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.codiceFiscaleSocio && (
                      <Text color="red.500" fontSize="sm">
                        {errors.codiceFiscaleSocio}
                      </Text>
                    )}
                  </FormControl>

                  {hasCompleteAddress && (
                    <FormControl
                      id="useUserAddress"
                      isInvalid={errors.useUserAddress}
                    >
                      <Checkbox
                        id="useUserAddress"
                        name="useUserAddress"
                        isChecked={formData.useUserAddress}
                        onChange={handleChange}
                        colorScheme="teal"
                      >
                        <Text display="inline" color={formTextColor}>
                          Usa l&apos;indirizzo di un tesseramento esistente
                        </Text>
                      </Checkbox>
                      {errors.useUserAddress && (
                        <Text color="red.500" fontSize="sm" mt={1}>
                          {errors.useUserAddress}
                        </Text>
                      )}
                    </FormControl>
                  )}

                  {(!formData.useUserAddress || errors.useUserAddress) && (
                    <>
                      <FormControl
                        id="indirizzoVia"
                        isRequired
                        isInvalid={errors.indirizzoVia}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Via)
                        </FormLabel>
                        <Input
                          id="indirizzoVia"
                          name="indirizzoVia"
                          type="text"
                          value={formData.indirizzoVia}
                          onChange={handleChange}
                          onBlur={validateForm}
                          color={formTextColor}
                        />
                        {errors.indirizzoVia && (
                          <Text color="red.500" fontSize="sm">
                            {errors.indirizzoVia}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        id="indirizzoCitta"
                        isRequired
                        isInvalid={errors.indirizzoCitta}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (Città)
                        </FormLabel>
                        <Input
                          id="indirizzoCitta"
                          name="indirizzoCitta"
                          type="text"
                          value={formData.indirizzoCitta}
                          onChange={handleChange}
                          onBlur={validateForm}
                          color={formTextColor}
                        />
                        {errors.indirizzoCitta && (
                          <Text color="red.500" fontSize="sm">
                            {errors.indirizzoCitta}
                          </Text>
                        )}
                      </FormControl>

                      <FormControl
                        id="indirizzoCap"
                        isRequired
                        isInvalid={errors.indirizzoCap}
                      >
                        <FormLabel fontWeight="600" color={formLabelColor}>
                          Indirizzo (CAP)
                        </FormLabel>
                        <Input
                          id="indirizzoCap"
                          name="indirizzoCap"
                          type="text"
                          value={formData.indirizzoCap}
                          onChange={handleChange}
                          onBlur={validateForm}
                          color={formTextColor}
                        />
                        {errors.indirizzoCap && (
                          <Text color="red.500" fontSize="sm">
                            {errors.indirizzoCap}
                          </Text>
                        )}
                      </FormControl>
                    </>
                  )}
                </>
              )}

              {step === 2 && (
                <>
                  <FormControl
                    id="precauzioniSanitarie"
                    isInvalid={errors.precauzioniSanitarie}
                  >
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Precauzioni Sanitarie
                    </FormLabel>
                    <Textarea
                      id="precauzioniSanitarie"
                      name="precauzioniSanitarie"
                      value={formData.precauzioniSanitarie}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.precauzioniSanitarie && (
                      <Text color="red.500" fontSize="sm">
                        {errors.precauzioniSanitarie}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl id="interessi" isInvalid={errors.interessi}>
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Interessi
                    </FormLabel>
                    <CheckboxGroup
                      value={formData.interessi}
                      onChange={handleInteressiChange}
                    >
                      <Stack spacing={2} direction="column">
                        {options.interessi.map((option) => (
                          <Checkbox
                            key={option}
                            value={option}
                            colorScheme="teal"
                          >
                            {option}
                          </Checkbox>
                        ))}
                      </Stack>
                    </CheckboxGroup>
                    {errors.interessi && (
                      <Text color="red.500" fontSize="sm">
                        {errors.interessi}
                      </Text>
                    )}
                  </FormControl>

                  <Divider />

                  <FormControl
                    id="autorizzazioneFotografie"
                    isInvalid={errors.autorizzazioneFotografie}
                  >
                    <Checkbox
                      id="autorizzazioneFotografie"
                      name="autorizzazioneFotografie"
                      isChecked={formData.autorizzazioneFotografie}
                      onChange={handleChange}
                      colorScheme="teal"
                    >
                      <Text display="inline" color={formTextColor}>
                        Autorizzazione Fotografie
                      </Text>
                      <Tooltip
                        label="Consente l'utilizzo e la pubblicazione delle tue fotografie per scopi di archivio e documentazione delle attività."
                        fontSize="sm"
                        hasArrow
                      >
                        <Text
                          as="span"
                          ml={2}
                          color="gray.500"
                          cursor="pointer"
                        >
                          ?
                        </Text>
                      </Tooltip>
                    </Checkbox>
                    {errors.autorizzazioneFotografie && (
                      <Text color="red.500" fontSize="sm">
                        {errors.autorizzazioneFotografie}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="consensoPubblicazione"
                    isInvalid={errors.consensoPubblicazione}
                  >
                    <Checkbox
                      id="consensoPubblicazione"
                      name="consensoPubblicazione"
                      isChecked={formData.consensoPubblicazione}
                      onChange={handleChange}
                      colorScheme="teal"
                    >
                      <Text display="inline" color={formTextColor}>
                        Consenso Pubblicazione
                      </Text>
                      <Tooltip
                        label="Acconsenti alla pubblicazione delle fotografie e contenuti multimediali quali audio e video sul web e sui social."
                        fontSize="sm"
                        hasArrow
                      >
                        <Text
                          as="span"
                          ml={2}
                          color="gray.500"
                          cursor="pointer"
                        >
                          ?
                        </Text>
                      </Tooltip>
                    </Checkbox>
                    {errors.consensoPubblicazione && (
                      <Text color="red.500" fontSize="sm">
                        {errors.consensoPubblicazione}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl
                    id="terminiCondizioni"
                    isInvalid={errors.terminiCondizioni}
                  >
                    <Checkbox
                      id="terminiCondizioni"
                      name="terminiCondizioni"
                      isChecked={formData.terminiCondizioni}
                      onChange={handleChange}
                      colorScheme="teal"
                    >
                      <Text color={formTextColor}>Termini e Condizioni</Text>
                    </Checkbox>
                    {errors.terminiCondizioni && (
                      <Text color="red.500" fontSize="sm">
                        {errors.terminiCondizioni}
                      </Text>
                    )}
                  </FormControl>

                  <TermsConditions />

                  <Divider />

                  <FormControl id="data" isRequired isInvalid={errors.data}>
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Data
                    </FormLabel>
                    <Input
                      type="date"
                      value={formData.data}
                      isReadOnly
                      color={formTextColor}
                    />
                    {errors.data && (
                      <Text color="red.500" fontSize="sm">
                        {errors.data}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl id="luogo" isRequired isInvalid={errors.luogo}>
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Luogo
                    </FormLabel>
                    <Input
                      id="luogo"
                      name="luogo"
                      type="text"
                      value={formData.luogo}
                      onChange={handleChange}
                      onBlur={validateForm}
                      color={formTextColor}
                    />
                    {errors.luogo && (
                      <Text color="red.500" fontSize="sm">
                        {errors.luogo}
                      </Text>
                    )}
                  </FormControl>

                  <FormControl id="firma" isRequired isInvalid={errors.firma}>
                    <FormLabel fontWeight="600" color={formLabelColor}>
                      Firma
                    </FormLabel>
                    <SignatureCanvas
                      ref={sigCanvas}
                      penColor={useColorModeValue('black', 'white')}
                      canvasProps={{
                        style: {
                          width: '100%',
                          height: '150px',
                          border: '1px solid #dddddd',
                          borderRadius: '8px',
                          backgroundColor: useColorModeValue(
                            'white',
                            'gray.700'
                          ),
                        },
                        className: 'sigCanvas',
                      }}
                      onEnd={validateForm}
                    />
                    <Button
                      mt={2}
                      mb={2}
                      width="full"
                      onClick={clearSignature}
                      size="sm"
                      colorScheme="teal"
                    >
                      Ripristina Firma
                    </Button>
                    {errors.firma && (
                      <Text textAlign="center" color="red.500" fontSize="sm">
                        {errors.firma}
                      </Text>
                    )}
                  </FormControl>
                </>
              )}

              {formData.paymentMethod !== 'elettronico' && (
                <HStack spacing={4} justify="end" mt={4}>
                  {step > 1 && !socioCreated?.documentId && (
                    <Button
                      onClick={handleBack}
                      variant="outline"
                      colorScheme="teal"
                    >
                      Indietro
                    </Button>
                  )}
                  {step < totalSteps && (
                    <Button
                      colorScheme="teal"
                      onClick={handleNext}
                      isDisabled={!isFormValid}
                      isLoading={loading}
                    >
                      Avanti
                    </Button>
                  )}
                  {step === totalSteps && (
                    <Button
                      colorScheme="teal"
                      type="submit"
                      isLoading={loading}
                      isDisabled={!isFormValid}
                    >
                      Conferma
                    </Button>
                  )}
                </HStack>
              )}

              {/* Error Alert */}
              {submissionStatus === 'error' && (
                <Alert status="error" mt={4}>
                  <AlertIcon />
                  <AlertTitle>Errore!</AlertTitle>
                  <AlertDescription>
                    Si è verificato un errore durante il tesseramento.
                  </AlertDescription>
                </Alert>
              )}
            </VStack>
          </form>
        </>
      )}
    </Box>
  );
};

export default TesseramentoFormMinore;
